import { SupplierDetailsModel } from '../models/suppliers/supplier-details-model';
import { SupplierModel } from 'src/app/shared/models/supplier/supplier-model';
import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { QueryModel } from 'src/app/shared/models/query/queryModel';
import { Observable } from 'rxjs';
import { PaginationModel } from 'src/app/shared/models/pagination/pagination-model';
import { UserModel } from 'src/app/shared/models/users/user-model';
import { CompanyModel } from '../models/companies/company-model';


@Injectable({
  providedIn: 'root'
})
export class AdnocUsersService {

  clientsPhotoChanged: EventEmitter<any> = new EventEmitter();

  constructor(private http: HttpClient) { }

  private resource = `${environment.serverUrl}/users/`;

  getAdnocUsers(queryModel: QueryModel): Observable<PaginationModel<UserModel>> {
    const url = `${this.resource}adnocusers/page/${queryModel.page}`;
    return this.http.post<any>(url, queryModel);
  }

  getAdnocUser(id: string): Observable<UserModel> {
    return this.http.get<UserModel>(`${this.resource}${id}`);
  }

  getAdnocUsersProfilePicture(): Observable<string> {
    const url = `${this.resource}picture`;
    return this.http.get<any>(url);
  }

  createAdnocUser(adnocUser: UserModel): Observable<UserModel> {
    return this.http.post<UserModel>(`${this.resource}`, adnocUser);
  }

  deleteAdnocUser(id: string) {
    return this.http.delete<any>(`${this.resource}${id}`);
  }

}
